import React, { useEffect, useState } from "react";
import "./style.css";
import ProfDashboardLayout from "./ProfDashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { feedBackReply, getFeedbacks } from "../../../redux/actions/feedbacks";
import { base, errorHandler, formatTime } from "../../../constants/base";
import { toast } from "react-toastify";

const ProfRatingReview = () => {
  const dispatch = useDispatch();
  const feedbacks = useSelector((state) => state.feedbacks);
  const user = useSelector((state) => state.AuthSlice.user);
  const pagination = useSelector((state) => state?.feedbacks?.pagination);
  const [currentPage, setCurrentPage] = useState(pagination.current_page);

  useEffect(() => {
    dispatch(getFeedbacks(user?.id, currentPage));
  }, [currentPage]);

  // Handle page navigation
  const handlePageChange = (page) => {
    setCurrentPage(page);
  }

  // GIVE FEEDBACK HERE
  const [ratingTextBox, setRatingTextBox] = useState();
  const [getReviewData, setGetReviewData] = useState({})
  const ratingStars = getReviewData?.replies?.stars || 0;
  // STARS RATING
  const [rating, setRating] = useState(0);

  console.log(getReviewData, "review here");

  const handleRatingForm = async (e) => {
    e.preventDefault()

    const feedBackData = {
      user_id: getReviewData?.user_id,
      customer_id: getReviewData?.customer_id,
      service_id: getReviewData?.service_id,
      request_id: getReviewData?.request_id,
      feedback_id: getReviewData?.id,
      stars: rating,
      message: ratingTextBox
    }

    console.log(feedBackData);

    const res = await dispatch(feedBackReply(feedBackData));

    if (res.type === 'feedBackReply/fulfilled') {
      if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
        const closeButton = document.querySelector("#close-btn-feedback-model");
        if (closeButton) {
          closeButton.click();
        }
        toast.success("Your feedback has been successfully submitted");
        await dispatch(getFeedbacks(user?.id, currentPage));
        setRatingTextBox("")
        setRating(0)
      } else {
        errorHandler(res.payload.errors);
      }
    } else if (res.type === 'feedBackReply/rejected') {
      errorHandler(res.payload.errors);
    } else {
      toast.error('Sorry, something went wrong!');
    }
  }

  // Function to handle star click
  const handleRating = (index) => {
    setRating(index + 1);
  };

  return (
    <>
      <ProfDashboardLayout>
        {feedbacks?.data?.data.map((review, index) => {
          return <div className="rating-card-box" onClick={(e) => setGetReviewData(review)} data-bs-toggle="modal" href="#employe-model" role="button" key={index}>
            <div className="rating-image">
              <img src={`${base.imageUrl}${review?.customer?.images?.[0]?.path}`} alt="" />
            </div>

            <div className="review-text-main">
              <div className="review-text-box">
                <h1>
                  {review?.customer?.name} <p>{review?.service?.name}</p>{" "}
                  <div className="rating-box">
                    <span>
                      <i className="fa-solid fa-star"></i> {review?.stars}
                    </span>
                  </div>
                </h1>

                <h3>{formatTime(review?.created_at)}</h3>
              </div>

              <p>{review?.message}</p>
            </div>
          </div>
        })}

        {/* Pagination Controls */}
        <div className="pagination">
          {pagination.current_page > 1 && (
            <button onClick={() => handlePageChange(pagination.current_page - 1)}>&laquo; Previous</button>
          )}

          {[...Array(pagination.total_pages)].map((_, i) => (
            pagination.total_pages >= 2 ?
              <button
                key={i + 1}
                className={i + 1 === pagination.current_page ? 'active' : ''}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
              : ""
          ))}

          {pagination.current_page < pagination.total_pages && (
            <button onClick={() => handlePageChange(pagination.current_page + 1)}>Next &raquo;</button>
          )}
        </div>
      </ProfDashboardLayout>

      <div className="modal fade" id="employe-model" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
        <div className="modal-dialog modal-dialog-centered service-add-model model-width-control">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" id='close-btn-feedback-model' className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
            </div>

            <div className="modal-body">

              {getReviewData?.replies ? <div className="about-text-box">

                <h2 className="mt-0">Your Service Is Completed</h2>

                <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      className={`star ${star <= ratingStars ? 'yellow-star' : 'grey-star'}`}
                      data-value={star}
                    >
                      <i className="fa-solid fa-star"></i>
                    </span>
                  ))}
                  <span className="star">({getReviewData?.replies?.stars}.0)</span>
                </div>
                <p className="common-text" style={{ textTransform: 'capitalize' }}>{getReviewData?.replies?.message}</p>
                <span className='category-box title-box-text'>Completed</span>
              </div> : <div className="about-text-box">
                <h2 className='mb-0 mt-0'>Give Your Feedback</h2>
                <form action="" onSubmit={handleRatingForm}>
                  <div className="select-stars-rating mb-2" style={{ display: "flex", gap: "5px" }}>
                    {[...Array(5)].map((_, index) => (
                      <span
                        key={index}
                        style={{
                          fontSize: "24px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRating(index)}
                      >
                        <i style={{ color: index < rating ? "gold" : "gray", }} className="fa-solid fa-star"></i>
                      </span>
                    ))}
                  </div>

                  <div className="custom-input-box about-company-textarea">
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="Leave a Review"
                      rows="3"
                      onChange={(e) => setRatingTextBox(e.target.value)}
                      value={ratingTextBox}
                      minLength={5}
                    ></textarea>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button className="category-box title-box-text" style={{ cursor: "pointer" }}>
                      {feedbacks?.feedbackReplyLoading ? <i
                        style={{ fontSize: "22px" }}
                        className="fa-solid fa-spinner fa-spin"
                      ></i> : "Submit Review"}
                    </button>
                  </div>
                </form>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfRatingReview;
